import { schema, normalize } from "normalizr"
import { arrayify } from "lib/utils/helpers/array"

export const prerequisiteSchema = new schema.Entity(
    "prerequisites",
    {},
    { idAttribute: "prerequisiteHash" },
)

export default originalData => {
    const {
        result: keys,
        entities: { prerequisites: normalizedData },
    } = normalize(arrayify(originalData), [prerequisiteSchema])

    return [keys || [], normalizedData || {}]
}
